import { CloseOutlined } from '@ant-design/icons'
import { IconButton } from '../IconButton'
import { Typography } from '../Typography'

import { useGetAccountInfo } from '@/queries/account/useGetAccountInfo'
import { Trans, useTranslation } from 'react-i18next'
import { Icon } from '../Icon'
import styles from './styles.module.scss'
import { useImpersonationBanner } from './useImpersonationBanner'

export const ImpersonatingBanner = () => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'components.impersonatingBanner',
  })

  const { accountId, canBannerBeShown, saveIsPrevClosed } = useImpersonationBanner()

  const accountInfo = useGetAccountInfo({ accountId })

  const handleClose = () => {
    saveIsPrevClosed(true)
  }

  if (accountInfo.isPending || !canBannerBeShown) return null

  return (
    <div className={styles.container}>
      <Typography.Text className={styles.text}>
        <Trans
          t={t}
          i18nKey="title"
          values={{ accountName: accountInfo.data?.accountName }}
          components={{ bold: <Typography.Text strong /> }}
        />
      </Typography.Text>

      <IconButton
        title={t('actions.close.title')}
        onClick={handleClose}
        className={styles.button}
        icon={<Icon size="0.75rem" color="white" icon={<CloseOutlined />} />}
      />
    </div>
  )
}
